import { connectResources } from '@ds-frontend/resource'
import get from 'lodash/get'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import { compose } from 'redux'

import AboutBoaContainer from './AboutBoaContainer'


export default compose(
  connectResources({
    namespace: 'aboutBoa',
    endpoint: 'api/v1/pages/:aboutLink',
  }),
  withRouter,
  connect((_, props) => ({
    quote: get(props, 'router.query.id', ''),
  })),
)(AboutBoaContainer)
